import { LogoutOutlined } from "@ant-design/icons";
import { Button } from "antd";

const logout = () => {
  localStorage.clear();
  window.location.href = "/login";
};
const items = [
  {
    key: "1",
    label: (
      <Button onClick={logout} icon={<LogoutOutlined rev={undefined} />}>
        Đăng xuất
      </Button>
    ),
  },
];

export { items, logout };
